import { useEffect, useState, useRef } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Polls the backend every interval to check if the Twitch channel is live.
// Backend proxies decapi.me so we don't need Twitch OAuth.
export const useLiveStatus = (intervalMs = 60000) => {
    const [isLive, setIsLive] = useState(false);
    const [loading, setLoading] = useState(true);
    const [lastChecked, setLastChecked] = useState(null);
    const mounted = useRef(true);

    useEffect(() => {
        mounted.current = true;
        let timer;

        const fetchStatus = async () => {
            try {
                const { data } = await axios.get(`${API}/twitch/live-status`, { timeout: 8000 });
                if (mounted.current) {
                    setIsLive(Boolean(data?.is_live));
                    setLastChecked(new Date());
                }
            } catch (e) {
                if (mounted.current) setIsLive(false);
            } finally {
                if (mounted.current) setLoading(false);
            }
        };

        fetchStatus();
        timer = setInterval(fetchStatus, intervalMs);

        // Re-fetch immediately when the owner changes the override
        const onOverride = () => fetchStatus();
        window.addEventListener("ool:live-override-changed", onOverride);

        return () => {
            mounted.current = false;
            clearInterval(timer);
            window.removeEventListener("ool:live-override-changed", onOverride);
        };
    }, [intervalMs]);

    return { isLive, loading, lastChecked };
};
